module.exports = "/_next/static/images/9f61979bf611adc58971edfab14eac8e-cristina-mobile.jpg.webp";